module.exports = __webpack_public_path__ + "img/台灣大哥大(原台灣之星).30619c81.png";